import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { loginRoute } from "../../../routes/reactRoutes";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Redux/authenticationSlice";
import { Box, Typography } from "@mui/material";
import { logoutRoute } from "../../../routes/apiRoutes";
import { send } from "../../../Redux/deviceSlice";
import axiosInstance from "../../../axios/axiosInstance";
import { resetPalette } from "../../../Redux/themeSlice";
import { t } from "i18next";
import { reset } from "../../../Redux/notificationSlice";

export default function AlertDialog(props) {
  const deviceId = useSelector((state) => state.deviceValues.deviceId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCancel = () => {
    props.setOpenLogout(false);
  };
  const handleLogout = async () => {
    try {
      await axiosInstance.post(
        `${logoutRoute}`,
        { deviceId: deviceId },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      props.setOpenLogout(false);
      dispatch(send({ deviceId: null }));
      dispatch(logout());
      dispatch(resetPalette());
      dispatch(reset());
      navigate(loginRoute);

    } catch (error) {
      dispatch(logout());
      dispatch(resetPalette());
      dispatch(reset());
      navigate(loginRoute);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleCancel}
        aria-labelledby="logout-dialog"
        aria-describedby="logout-dialog"
      >
        <Box
          sx={{
            p: 5,
            gap: 2,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{ fontSize: "1.5rem", fontWeight: 600, textAlign: "center" }}
          >
            {t("confirmation")}
          </Typography>
          <Typography>{t("logoutconfirmation")}</Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button
              sx={{ width: 150, py: 1, fontSize: "1rem" }}
              variant="outlined"
              onClick={handleCancel}
            >
              {t("cancel")}
            </Button>
            <Button
              sx={{ width: 150, py: 1, fontSize: "1rem" }}
              variant="contained"
              onClick={handleLogout}
            >
              {t("yes")}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
